// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { GetLifetimeExemptionDetails_ClientProfileFragment } from '../../../../../pages/designer/GiftDesigner/graphql/GetLifetimeExemptionDetails.generated';
import { gql } from '@apollo/client';
import { GetLifetimeExemptionDetails_ClientProfileFragmentDoc } from '../../../../../pages/designer/GiftDesigner/graphql/GetLifetimeExemptionDetails.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type HypotheticalTransferModalExemption_EstateWaterfallHypotheticalTransferFragment = { __typename?: 'EstateWaterfallHypotheticalTransfer', id: string, transferValue?: CurrencyUSD | null, startYear?: number | null, endYear?: number | null, transferTaxKind: Types.EstateWaterfallHypotheticalTransferTransferTaxKind, taxDiscount?: Percent | null, giftingGrantors?: Array<{ __typename?: 'ClientProfile', id: string }> | null };

export type HypotheticalTransferModalExemption_ClientProfileFragment = (
  { __typename?: 'ClientProfile', id: string, firstName: string, address?: { __typename?: 'Address', id: string, stateCode: string } | null }
  & GetLifetimeExemptionDetails_ClientProfileFragment
);

export type HypotheticalTransferModalExemption_Beneficiaries_ClientProfileFragment = { __typename?: 'ClientProfile', id: string, firstName: string, relationships?: Array<{ __typename?: 'ClientProfileRelationship', id: string, type: Types.ClientProfileRelationshipType, toClientProfile: { __typename?: 'ClientProfile', id: string } }> | null };

export type HypotheticalTransferModalExemption_EntityFragment = { __typename?: 'Entity', id: string, subtype: { __typename?: 'CCorpBusinessEntity', id: string } | { __typename?: 'CLTTrust', gstStatus?: Types.EntityGstStatus | null, currentValue: CurrencyUSD, id: string } | { __typename?: 'CRTTrust', gstStatus?: Types.EntityGstStatus | null, currentValue: CurrencyUSD, id: string } | { __typename?: 'CustodialPersonalAccount', gstStatus?: Types.EntityGstStatus | null, currentValue: CurrencyUSD, id: string } | { __typename?: 'DonorAdvisedFund', gstStatus?: Types.EntityGstStatus | null, currentValue: CurrencyUSD, id: string } | { __typename?: 'GPBusinessEntity', id: string } | { __typename?: 'GRATTrust', gstStatus?: Types.EntityGstStatus | null, currentValue: CurrencyUSD, id: string } | { __typename?: 'ILITTrust', gstStatus?: Types.EntityGstStatus | null, currentValue: CurrencyUSD, id: string } | { __typename?: 'IndividualPersonalAccount', gstStatus?: Types.EntityGstStatus | null, currentValue: CurrencyUSD, id: string } | { __typename?: 'InsurancePersonalAccount', gstStatus?: Types.EntityGstStatus | null, currentValue: CurrencyUSD, id: string } | { __typename?: 'IrrevocableTrust', gstStatus?: Types.EntityGstStatus | null, currentValue: CurrencyUSD, id: string } | { __typename?: 'JointPersonalAccount', gstStatus?: Types.EntityGstStatus | null, currentValue: CurrencyUSD, id: string } | { __typename?: 'LLCBusinessEntity', id: string } | { __typename?: 'LPBusinessEntity', id: string } | { __typename?: 'PrivateFoundation', gstStatus?: Types.EntityGstStatus | null, currentValue: CurrencyUSD, id: string } | { __typename?: 'QPRTTrust', gstStatus?: Types.EntityGstStatus | null, currentValue: CurrencyUSD, id: string } | { __typename?: 'QualifiedTuitionPersonalAccount', gstStatus?: Types.EntityGstStatus | null, currentValue: CurrencyUSD, id: string } | { __typename?: 'RetirementPersonalAccount', gstStatus?: Types.EntityGstStatus | null, currentValue: CurrencyUSD, id: string } | { __typename?: 'RevocableTrust', gstStatus?: Types.EntityGstStatus | null, currentValue: CurrencyUSD, id: string } | { __typename?: 'SCorpBusinessEntity', id: string } | { __typename?: 'SLATTrust', gstStatus?: Types.EntityGstStatus | null, currentValue: CurrencyUSD, id: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string } };

export type HypotheticalTransferModalExemption_EstateWaterfallFragment = { __typename?: 'EstateWaterfall', id: string, hypotheticalTransfers: { __typename?: 'EstateWaterfallHypotheticalTransferConnection', edges?: Array<{ __typename?: 'EstateWaterfallHypotheticalTransferEdge', node?: (
        { __typename?: 'EstateWaterfallHypotheticalTransfer' }
        & HypotheticalTransferModalExemption_EstateWaterfallHypotheticalTransferFragment
      ) | null } | null> | null }, household: { __typename?: 'Household', id: string, possiblePrimaryClients: Array<(
      { __typename?: 'ClientProfile' }
      & HypotheticalTransferModalExemption_ClientProfileFragment
    )>, clientProfiles?: Array<(
      { __typename?: 'ClientProfile' }
      & HypotheticalTransferModalExemption_Beneficiaries_ClientProfileFragment
    )> | null, entities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: (
          { __typename?: 'Entity' }
          & HypotheticalTransferModalExemption_EntityFragment
        ) | null } | null> | null } } };

export type HypotheticalTransferModalExemptionQueryVariables = Types.Exact<{
  estateWaterfallWhere: Types.EstateWaterfallWhereInput;
}>;


export type HypotheticalTransferModalExemptionQuery = { __typename?: 'Query', estateWaterfalls: { __typename?: 'EstateWaterfallConnection', edges?: Array<{ __typename?: 'EstateWaterfallEdge', node?: (
        { __typename?: 'EstateWaterfall' }
        & HypotheticalTransferModalExemption_EstateWaterfallFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    HypotheticalTransferModalExemption: 'HypotheticalTransferModalExemption' as const
  },
  Fragment: {
    HypotheticalTransferModalExemption_EstateWaterfallHypotheticalTransfer: 'HypotheticalTransferModalExemption_EstateWaterfallHypotheticalTransfer' as const,
    HypotheticalTransferModalExemption_ClientProfile: 'HypotheticalTransferModalExemption_ClientProfile' as const,
    HypotheticalTransferModalExemption_Beneficiaries_ClientProfile: 'HypotheticalTransferModalExemption_Beneficiaries_ClientProfile' as const,
    HypotheticalTransferModalExemption_Entity: 'HypotheticalTransferModalExemption_Entity' as const,
    HypotheticalTransferModalExemption_EstateWaterfall: 'HypotheticalTransferModalExemption_EstateWaterfall' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const HypotheticalTransferModalExemption_EstateWaterfallHypotheticalTransferFragmentDoc = gql`
    fragment HypotheticalTransferModalExemption_EstateWaterfallHypotheticalTransfer on EstateWaterfallHypotheticalTransfer {
  id
  transferValue
  startYear
  endYear
  transferTaxKind
  giftingGrantors {
    id
  }
  taxDiscount
}
    `;
export const HypotheticalTransferModalExemption_ClientProfileFragmentDoc = gql`
    fragment HypotheticalTransferModalExemption_ClientProfile on ClientProfile {
  id
  firstName
  address {
    id
    stateCode
  }
  ...GetLifetimeExemptionDetails_ClientProfile
}
    ${GetLifetimeExemptionDetails_ClientProfileFragmentDoc}`;
export const HypotheticalTransferModalExemption_Beneficiaries_ClientProfileFragmentDoc = gql`
    fragment HypotheticalTransferModalExemption_Beneficiaries_ClientProfile on ClientProfile {
  id
  firstName
  relationships {
    id
    toClientProfile {
      id
    }
    type
  }
}
    `;
export const HypotheticalTransferModalExemption_EntityFragmentDoc = gql`
    fragment HypotheticalTransferModalExemption_Entity on Entity {
  id
  subtype {
    id
    ... on CLTTrust {
      gstStatus
      currentValue
    }
    ... on CRTTrust {
      gstStatus
      currentValue
    }
    ... on CustodialPersonalAccount {
      gstStatus
      currentValue
    }
    ... on DonorAdvisedFund {
      gstStatus
      currentValue
    }
    ... on GRATTrust {
      gstStatus
      currentValue
    }
    ... on ILITTrust {
      gstStatus
      currentValue
    }
    ... on IndividualPersonalAccount {
      gstStatus
      currentValue
    }
    ... on InsurancePersonalAccount {
      gstStatus
      currentValue
    }
    ... on IrrevocableTrust {
      gstStatus
      currentValue
    }
    ... on JointPersonalAccount {
      gstStatus
      currentValue
    }
    ... on PersonalAccount {
      gstStatus
      currentValue
    }
    ... on PrivateFoundation {
      gstStatus
      currentValue
    }
    ... on QPRTTrust {
      gstStatus
      currentValue
    }
    ... on QualifiedTuitionPersonalAccount {
      gstStatus
      currentValue
    }
    ... on RetirementPersonalAccount {
      gstStatus
      currentValue
    }
    ... on RevocableTrust {
      gstStatus
      currentValue
    }
    ... on SLATTrust {
      gstStatus
      currentValue
    }
  }
}
    `;
export const HypotheticalTransferModalExemption_EstateWaterfallFragmentDoc = gql`
    fragment HypotheticalTransferModalExemption_EstateWaterfall on EstateWaterfall {
  id
  hypotheticalTransfers {
    edges {
      node {
        ...HypotheticalTransferModalExemption_EstateWaterfallHypotheticalTransfer
      }
    }
  }
  household {
    id
    possiblePrimaryClients {
      ...HypotheticalTransferModalExemption_ClientProfile
    }
    clientProfiles {
      ...HypotheticalTransferModalExemption_Beneficiaries_ClientProfile
    }
    entities {
      edges {
        node {
          ...HypotheticalTransferModalExemption_Entity
        }
      }
    }
  }
}
    ${HypotheticalTransferModalExemption_EstateWaterfallHypotheticalTransferFragmentDoc}
${HypotheticalTransferModalExemption_ClientProfileFragmentDoc}
${HypotheticalTransferModalExemption_Beneficiaries_ClientProfileFragmentDoc}
${HypotheticalTransferModalExemption_EntityFragmentDoc}`;
export const HypotheticalTransferModalExemptionDocument = gql`
    query HypotheticalTransferModalExemption($estateWaterfallWhere: EstateWaterfallWhereInput!) {
  estateWaterfalls(where: $estateWaterfallWhere) {
    edges {
      node {
        ...HypotheticalTransferModalExemption_EstateWaterfall
      }
    }
  }
}
    ${HypotheticalTransferModalExemption_EstateWaterfallFragmentDoc}`;

/**
 * __useHypotheticalTransferModalExemptionQuery__
 *
 * To run a query within a React component, call `useHypotheticalTransferModalExemptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useHypotheticalTransferModalExemptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHypotheticalTransferModalExemptionQuery({
 *   variables: {
 *      estateWaterfallWhere: // value for 'estateWaterfallWhere'
 *   },
 * });
 */
export function useHypotheticalTransferModalExemptionQuery(baseOptions: Apollo.QueryHookOptions<HypotheticalTransferModalExemptionQuery, HypotheticalTransferModalExemptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HypotheticalTransferModalExemptionQuery, HypotheticalTransferModalExemptionQueryVariables>(HypotheticalTransferModalExemptionDocument, withFetchPolicyContext(options));
      }
export function useHypotheticalTransferModalExemptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HypotheticalTransferModalExemptionQuery, HypotheticalTransferModalExemptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HypotheticalTransferModalExemptionQuery, HypotheticalTransferModalExemptionQueryVariables>(HypotheticalTransferModalExemptionDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useHypotheticalTransferModalExemptionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HypotheticalTransferModalExemptionQuery, HypotheticalTransferModalExemptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HypotheticalTransferModalExemptionQuery, HypotheticalTransferModalExemptionQueryVariables>(HypotheticalTransferModalExemptionDocument, withFetchPolicyContext(options));
        }
export type HypotheticalTransferModalExemptionQueryHookResult = ReturnType<typeof useHypotheticalTransferModalExemptionQuery>;
export type HypotheticalTransferModalExemptionLazyQueryHookResult = ReturnType<typeof useHypotheticalTransferModalExemptionLazyQuery>;
export type HypotheticalTransferModalExemptionSuspenseQueryHookResult = ReturnType<typeof useHypotheticalTransferModalExemptionSuspenseQuery>;
export type HypotheticalTransferModalExemptionQueryResult = Apollo.QueryResult<HypotheticalTransferModalExemptionQuery, HypotheticalTransferModalExemptionQueryVariables>;